<template>
	<card :flat="props.flat">
		<div class="flex items-center justify-center flex-column sm:flex-row stretch-layout px-24 py-32">
			<div v-if="props.image" class="mb-24 sm:mb-0 sm:mr-48">
				<cdn-image :src="props.image" :width="200"/>
			</div>

			<div class="max-w-600">
				<p v-if="props.title" class="subheading text-md">{{ props.title }}</p>
				<p class="subheading-description text-sm">{{ props.description }}</p>

				<p v-if="props.authRequired && !$auth.loggedIn" class="subheading-description text-sm">{{ $t('action.login_to_use_feature') }}</p>

				<wrapper grow left break-column="sm" class="mt-24">
					<slot name="buttons"/>
					<btn v-if="props.authRequired && !$auth.loggedIn" :to="$spoferanUrl(`/login?redirect=${$route.fullPath}`)" color="success" nofollow @click="emit('login')">
						<span>{{ $t('action.login') }}</span>
					</btn>
				</wrapper>
			</div>
		</div>
	</card>
</template>

<script setup lang="ts">
const props = defineProps<{
	image?: string,
	title?: string,
	description: string,
	authRequired?: boolean,
	flat?: boolean,
}>();
const emit = defineEmits(['login']);
</script>